"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _RecentTradesComponent = _interopRequireDefault(require("./RecentTradesComponent"));
var _recentTradesSelectors = require("../../redux/selectors/recentTradesSelectors");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var recentTrades = (0, _recentTradesSelectors.recentTradesSelector)(state);
  var fetching = state.recentTrades.fetching;
  return {
    recentTrades: recentTrades,
    fetching: fetching,
    selectedInstrument: (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_RecentTradesComponent["default"]);